export default __webpack_public_path__ + "static/media/25.b2ba32bd.jpg";